import React from "react";
import Oneday from "./Oneday";
import Sevenday from "./Sevenday";

function Tabbing() {
  return (
    <div className="pt120 pb-3">
      <div className="d-flex justify-content-between align-items-center pb-lg-4 pb-2">
        <div>
          <h3>top Collections</h3>
        </div>

        <ul
          className="nav nav-tabs daysTab align-items-center justify-content-center d-lg-flex d-none"
          id="myTab"
          role="tablist"
        >
          <li className="nav-item smallScreenTab" role="presentation">
            <button
              className="nav-link rounded-3 active "
              id="forbes-tab"
              data-bs-toggle="tab"
              data-bs-target="#forbes"
              type="button"
              role="tab"
              aria-controls="forbes"
              aria-selected="true"
            >
              1 day
            </button>
          </li>
          <li className="nav-item " role="presentation">
            <button
              className="nav-link rounded-3"
              id="epicurious-tab"
              data-bs-toggle="tab"
              data-bs-target="#epicurious"
              type="button"
              role="tab"
              aria-controls="epicurious"
              aria-selected="false"
            >
              7 day
            </button>
          </li>
          <li className="nav-item " role="presentation">
            <button
              className="nav-link rounded-3"
              id="smarthatrawet-tab"
              data-bs-toggle="tab"
              data-bs-target="#smarthatrawet"
              type="button"
              role="tab"
              aria-controls="smarthatrawet"
              aria-selected="false"
            >
              30 day
            </button>
          </li>
        </ul>

        <div>
          <button className="allbutton border border-0">See all</button>
        </div>
      </div>
      <ul
        className="nav nav-tabs daysTab align-items-center justify-content-center d-lg-none d-flex"
        id="myTab"
        role="tablist"
      >
        <li className="nav-item smallScreenTab" role="presentation">
          <button
            className="nav-link rounded-3 active "
            id="forbes-tab"
            data-bs-toggle="tab"
            data-bs-target="#forbes"
            type="button"
            role="tab"
            aria-controls="forbes"
            aria-selected="true"
          >
            1 day
          </button>
        </li>
        <li className="nav-item " role="presentation">
          <button
            className="nav-link rounded-3"
            id="epicurious-tab"
            data-bs-toggle="tab"
            data-bs-target="#epicurious"
            type="button"
            role="tab"
            aria-controls="epicurious"
            aria-selected="false"
          >
            7 day
          </button>
        </li>
        <li className="nav-item " role="presentation">
          <button
            className="nav-link rounded-3"
            id="smarthatrawet-tab"
            data-bs-toggle="tab"
            data-bs-target="#smarthatrawet"
            type="button"
            role="tab"
            aria-controls="smarthatrawet"
            aria-selected="false"
          >
            30 day
          </button>
        </li>
      </ul>

      <div className="tab-content pt-sm-5 pt-md-0 pt-4" id="myTabContent">
        <div
          className="tab-pane fade show active forbess"
          id="forbes"
          role="tabpanel"
          aria-labelledby="forbes-tab"
        >
          <Oneday />
        </div>
        <div
          className="tab-pane fade demo"
          id="epicurious"
          role="tabpanel"
          aria-labelledby="epicurious-tab"
        >
          <Sevenday />
        </div>
        <div
          className="tab-pane fade forbess"
          id="smarthatrawet"
          role="tabpanel"
          aria-labelledby="smarthatrawet-tab"
        >
          Forbes
        </div>
      </div>
    </div>
  );
}

export default Tabbing;
